import { SVGProps } from "react";

export function PrimaryFlightIcon (props:  SVGProps<SVGSVGElement>) {
    return <svg width="21" height="20" viewBox="0 0 21 20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.5 19.3059H8.5L13.5 11.3059H19C19.83 11.3059 20.5 10.6359 20.5 9.80591C20.5 8.97591 19.83 8.30591 19 8.30591L13.5 8.30591L8.5 0.305908L6.5 0.305908L9 8.30591H3.5L2 6.30591L0.5 6.30591L1.5 9.80591L0.5 13.3059L2 13.3059L3.5 11.3059L9 11.3059L6.5 19.3059Z" fill="currentColor"/>
    </svg>
}